import { Component, input } from '@angular/core';

import { PlaylistItem } from '../../services/api/multimedia.service';
import { environment } from '../../../environments/environment';

const { multimediaBaseUrl } = environment;

@Component({
  selector: 'app-multimedia',
  imports: [],
  templateUrl: './multimedia.html',
  styleUrl: './multimedia.scss'
})
export class Multimedia {
  multimedia = input<PlaylistItem>();

  getMultimediaUrl(item: PlaylistItem | null): string | null {
    if (!item) {
      return null;
    }
    return `${multimediaBaseUrl}${item.src}`;
  }
}
